export default function capitalize (value) {
  if (typeof value === 'string' || value instanceof String) {
    return value.charAt(0).toUpperCase() + value.slice(1);
  }
  return '';
}
